import { StackLayout } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryDriver = getMasonryDriver({
  rootNodeId: 'csb-autopay$root',
});

export const AutomaticPaymentSetupMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '784px',
      marginBottom: '$two',
    }}
  >
    <MasonryEngine driver={MasonryDriver} />
  </StackLayout>
);
